var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#662D91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1536 14.6154C15.4281 14.6154 16.4613 13.5822 16.4613 12.3077C16.4613 11.0332 15.4281 10 14.1536 10C12.8791 10 11.8459 11.0332 11.8459 12.3077C11.8459 13.5822 12.8791 14.6154 14.1536 14.6154Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.0766H18.3077V20.5762C18.3003 19.8726 18.1148 19.1824 17.7684 18.57C17.4219 17.9575 16.9259 17.4429 16.3267 17.0742C15.7275 16.7054 15.0445 16.4945 14.3417 16.4612C14.2791 16.4583 14.2164 16.4567 14.1538 16.4566C14.0913 16.4567 14.0286 16.4583 13.966 16.4612C13.2632 16.4945 12.5802 16.7054 11.981 17.0742C11.3818 17.4429 10.8858 17.9575 10.5393 18.57C10.1929 19.1824 10.0073 19.8726 10 20.5762V21.0766Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8461 14.6154C19.1206 14.6154 20.1538 13.5822 20.1538 12.3077C20.1538 11.0332 19.1206 10 17.8461 10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1538 21.0769H22V20.5764C21.9926 19.8728 21.8071 19.1826 21.4606 18.5702C21.1142 17.9577 20.6182 17.4431 20.019 17.0744C19.6317 16.836 19.2093 16.6636 18.7692 16.5625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsers);
export default __webpack_public_path__ + "static/media/total-users.d94bd1a3c34a54641a1963c4d0dc0fa8.svg";
export { ForwardRef as ReactComponent };